import { useCheckPatientModule } from 'infrastructure/hooks/patient/use-check-patient-module';
import {
  isCcmModule as isCcmModuleFunction,
  isCombinedModule as isCombinedModuleFunction,
  isRpmModule as isRpmModuleFunction,
} from 'infrastructure/functions';
import { useCheckRoleAccess } from 'infrastructure/hooks';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';
import { useDoctorInfo } from 'infrastructure/hooks/doctor';
import {
  CcmStatuses,
  RpmStatuses,
  type ModuleType,
} from 'infrastructure/enums';

interface IProps {
  patientGuid: string;
  module: ModuleType;
}

export const useAccess = (props: IProps) => {
  const { patientGuid, module } = props;
  const { patientInfo } = usePatientInfo({ patientGuid });
  const { doctorInfo } = useDoctorInfo({
    doctorGuid: patientInfo?.doctorGuid,
  });

  const { isBlockCcmModule, isBlockRpmModule } =
    useCheckPatientModule(patientGuid);

  const { isReadOnlyRole } = useCheckRoleAccess();

  const isCcmModule = isCcmModuleFunction(module);
  const isRpmModule = isRpmModuleFunction(module);
  const isCombinedModule = isCombinedModuleFunction(module);

  const isCcmActionAllowed = isCcmActionAllowedStatus(patientInfo?.ccmStatus!);
  const isCcmActionDisabled = !isCcmActionAllowed && isCcmModule;
  const isActiveRpmStatus = patientInfo?.status === RpmStatuses.Active;
  const isEnrolledCcmStatus = patientInfo?.ccmStatus === CcmStatuses.Enrolled;

  return {
    patientInfo,
    doctorInfo,
    isBlockCcmModule,
    isBlockRpmModule,
    isCcmModule,
    isRpmModule,
    isCombinedModule,
    isReadOnlyRole,
    isCcmActionAllowed,
    isCcmActionDisabled,
    isActiveRpmStatus,
    isEnrolledCcmStatus,
  };
};
